'use client';

import ErrorTemplate from './error-template';

export default function CustomError() {
  return (
    <ErrorTemplate
      headerTitle="Server Error"
      pageTitle="We're unable to load the page"
    >
      <p>
        Trust us, the irony isn’t lost on us. Press the back button above to
        return to your last point and try again, or return the main page and
        start again.
      </p>
    </ErrorTemplate>
  );
}
